import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { registerLocale } from "react-datepicker";
import es from "date-fns/locale/es";
registerLocale("es", es);

const DateRangePicker = ({ startDate, endDate, onChange }) => {
    const handleStartChange = (date) => {
        onChange({ startDate: date, endDate });
    };

    const handleEndChange = (date) => {
        onChange({ startDate, endDate: date });
    };

    return (
        <div style={{ display: "flex", gap: "1rem" }}>
            <div>
                <label className="me-1">Fecha de Inicio</label>
                <DatePicker
                    locale="es"
                    selected={startDate}
                    onChange={handleStartChange}
                    selectsStart
                    startDate={startDate}
                    endDate={endDate}
                    dateFormat="dd/MM/yyyy"
                />
            </div>
            <div>
                <label className="me-1">Fecha de Fin</label>
                <DatePicker
                    locale="es"
                    selected={endDate}
                    onChange={handleEndChange}
                    selectsEnd
                    startDate={startDate}
                    endDate={endDate}
                    minDate={startDate}
                    dateFormat="dd/MM/yyyy"
                />
            </div>
        </div>
    );
};

export default DateRangePicker;
